import { __decorate } from "tslib";
import { observable } from 'mobx';
import isNil from 'lodash/isNil';
export default class AttachmentFileChunk {
    constructor(chunk) {
        Object.keys(chunk).forEach(key => {
            const value = chunk[key];
            if (!isNil(value)) {
                this[key] = value;
            }
        });
    }
}
__decorate([
    observable
], AttachmentFileChunk.prototype, "percent", void 0);
